"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/input/style");
var _input = _interopRequireDefault(require("antd/lib/input"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _cookie = _interopRequireDefault(require("../../utils/cookie"));
var _consts = require("../../consts");
var _captcha = require("../../consts/captcha");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Simple = function Simple(props) {
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    captchaImg = _useState2[0],
    setCaptchaImg = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    value = _useState4[0],
    setValue = _useState4[1];
  var captchaItem = props.captchaItem,
    bId = props.bId,
    balanceCode = props.balanceCode,
    refreshCaptcha = props.refreshCaptcha,
    onChange = props.onChange,
    _props$refreshable = props.refreshable,
    refreshable = _props$refreshable === void 0 ? true : _props$refreshable,
    handleInitFunc = props.handleInitFunc,
    _props$idInput = props.idInput,
    idInput = _props$idInput === void 0 ? 'input_captcha' : _props$idInput,
    _props$idBtn = props.idBtn,
    idBtn = _props$idBtn === void 0 ? 'btn_captcha' : _props$idBtn,
    publicIp = props.publicIp;
  (0, _react.useEffect)(function () {
    if (Object.keys(captchaItem).length) {
      var gyUrl = captchaItem.gy_url.split(':')[1];
      setCaptchaImg("".concat(gyUrl, "?bid=").concat(bId));
    }
  }, [captchaItem]);
  var onChangeCaptcha = function onChangeCaptcha(e) {
    var value = e.target.value;
    setValue(value);
    onChange && onChange({
      completed: 4 <= value.trim().length
    });
    if (4 <= value.trim().length) {
      var cookies = _cookie.default.get(_consts.COOKIE_KEY);
      props.onSubmit(_objectSpread({
        captcha: value.trim(),
        cookies: cookies,
        balanceCode: balanceCode,
        type: _captcha.CAPTCHA_TYPE.gySimple
      }, publicIp && {
        publicIp: publicIp
      }));
    }
  };
  var onRefresh = function onRefresh() {
    handleInitFunc && handleInitFunc();
    setCaptchaImg("".concat(captchaImg, "&r=").concat(Math.random()));
  };
  (0, _react.useEffect)(function () {
    if (refreshCaptcha) {
      onRefresh();
      setValue('');
    }
  }, [refreshCaptcha]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('gy_captcha_simple', props.wrapClassName)
  }, /*#__PURE__*/_react.default.createElement(_input.default, {
    value: value,
    maxLength: 5,
    className: "gy_captcha_simple_input",
    onChange: onChangeCaptcha,
    id: idInput
  }), /*#__PURE__*/_react.default.createElement("img", {
    className: "gy_captcha_simple_img",
    src: captchaImg,
    alt: "\u770B\u4E0D\u6E05\u8BF7\u70B9\u6211",
    onClick: onRefresh,
    id: idBtn
  }), refreshable && /*#__PURE__*/_react.default.createElement("span", {
    className: "gy_captcha_simple_refresh",
    onClick: onRefresh
  }));
};
var _default = Simple;
exports.default = _default;